import { render, staticRenderFns } from "./surgaltiinTuv.vue?vue&type=template&id=24dddecc&"
import script from "./surgaltiinTuv.vue?vue&type=script&lang=js&"
export * from "./surgaltiinTuv.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports